// @flow
import React, { Component } from 'react'
import type { Node } from 'react'
import postJson from '../../services/postJson'

type Props = {|
  url: string,
  children: Node,
  requestParams?: Object,
  onStart?: () => void,
  onSuccess?: () => void,
  onFail?: () => void
|}

const t = {
  are_you_sure: 'Вы уверены?',
  request_failed: 'Возникла ошибка при выполнении запроса'
}

export default class AjaxDeleteButton extends Component<Props> {
  render() {
    return <span onClick={() => this.archivate()}>{this.props.children}</span>
  }

  archivate() {
    const { onStart, url, onSuccess, onFail, requestParams } = this.props

    if (!window.confirm(t.are_you_sure)) return

    onStart && onStart()
    const data = requestParams || {}
    postJson(url, data)
      .done(() => {
        onSuccess && onSuccess()
      })
      .fail(() => {
        window.alert(t.request_failed)
        onFail && onFail()
      })
  }
}
